// removed by extract-text-webpack-plugin
module.exports = {"root":"_2assB","answer":"_11VWX","text":"_2pWFG","active":"_282Jq","number":"_2zX3G","correct":"_3j41a","resultHint":"_1PS74","incorrect":"_2P5Og","textBlock":"_3WYuN"};


//////////////////
// WEBPACK FOOTER
// ./app/components/AnswerBlock/AnswerBlock.scss
// module id = 1170
// module chunks = 1